import type * as zod from 'zod'
import { COMMON_WIDGET_DATA_CONSTRUCTOR, COMMON_WIDGET_ELEMENT_DATA, LINE, WidgetElementSchema, WidgetSchema, type AbstractWidgetData, type BaseWidgetElementDialogProps, type PartialWidget, type PartialWidgetElement, type WidgetConstructor, type WidgetElementData } from './Common'
import type { BaseWidgetDataRequest, WidgetDataResponse } from './Widgets'
import type { DepartmentPageLine } from '../Device'
import type { SetRequiredDeep } from 'type-fest'

export type LineWidgetDataRequest = BaseWidgetDataRequest & {
  type: 'LINE'
  widget: LineWidget
}
export type LineWidgetOptionsResponse = WidgetDataResponse & {
  type: 'LINE'
  lines: LineWidgetElementData[]
}

export const LineWidgetElementSchema = WidgetElementSchema.extend({
  type: LINE,
})
export type LineWidgetElement = zod.infer<typeof LineWidgetElementSchema>
export type LineWidgetElementPartial = SetRequiredDeep<PartialWidgetElement<LineWidgetElement>, 'type'>

export const LineWidgetSchema = WidgetSchema.extend({
  type: LINE,
  elements: LineWidgetElementSchema.array(),
})
export type LineWidget = zod.infer<typeof LineWidgetSchema>
export type LineWidgetPartial = SetRequiredDeep<PartialWidget<LineWidget>, 'type' | 'elements' | `elements.${number}.type`>

export interface LineWidgetElementData extends WidgetElementData {
  readOnly: boolean
}
export interface LineWidgetData extends AbstractWidgetData<LineWidgetElementData> {
  type: 'LINE'
  elements: LineWidgetElementData[]
}
export interface LineWidgetElementDialogProps extends BaseWidgetElementDialogProps {
  type: 'LINE'
  line?: DepartmentPageLine
}

export const DEFAULT_LINE_WIDGET_ELEMENT: LineWidgetElementPartial = {
  ...COMMON_WIDGET_ELEMENT_DATA,
  type: 'LINE',
}

export const LINE_WIDGET_CONSTRUCTOR: WidgetConstructor<LineWidgetPartial> = () => ({
  type: 'LINE',
  ...COMMON_WIDGET_DATA_CONSTRUCTOR(),
  elements: [DEFAULT_LINE_WIDGET_ELEMENT],
})
